import { Label, makeStyles, Switch } from "@fluentui/react-components";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IWorkspaceFilterProps } from "./workspace-filter.props";
import { useEffect, useState } from "react";
import WorkspaceFilterItem from "./workspace-filter-item";
import { IWorkspaceFilterItem } from "@interfaces/common.interfaces";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1em'
    }
});

export default function WorkspaceFilter(props: IWorkspaceFilterProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const [applyFilter, setApplyFilter] = useState<boolean>(props.model?.applyFilter === true);
    const [filter, setFilter] = useState<IWorkspaceFilterItem | undefined>(props.model?.filter);

    useEffect(() => {
        if (!applyFilter) {
            setFilter(undefined);
            props.onChange({ applyFilter: applyFilter, filter: undefined });
        }
        else
            props.onChange({ applyFilter: applyFilter, filter: filter });
    }, [applyFilter, filter]);

    return (
        <div className={styles.mainWrapper}>
            <Switch
                defaultChecked={applyFilter}
                label={t('ppaApplyFilter')}
                onChange={(e, v) => { setApplyFilter(v.checked) }} />
            {applyFilter && <div>
                <Label>{t('ppaWorkspaceFilter')}</Label>
                <WorkspaceFilterItem filter={filter} onChange={(value) => { setFilter(value) }} />
            </div>}
        </div>
    );
}